/**
 * Created by Boris on 15/02/2017.
 */
export class TermsConditionsData {
  agreedToTsAndCs: boolean;
  authorisationTsAndCs: boolean;
  breachOfInfoTsAndCs?: boolean;
  discretionTsAndCs?: boolean;

  TermsConditionsData() {
    this.agreedToTsAndCs = false;
    this.authorisationTsAndCs = false;
    this.breachOfInfoTsAndCs = null;
    this.discretionTsAndCs = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-objects/terms-conditions-data.ts